import getCardTypes from "credit-card-type";

import {
  checkLuhn,
  notProperCreditCardType,
  notProperOptionalLength,
  notProperStringOfNumbers,
  unformatCardInput,
} from "cc-tools/helpers";
import { CardEligibile, CardNumberOptions } from "cc-tools/types";

export const cardNumberValidator = (
  value: string | unknown,
  // for custom merchant type payment cards
  options: CardNumberOptions = {}
): CardEligibile => {
  const rawCardValue: string = unformatCardInput(value);

  // Basic checks
  if (notProperStringOfNumbers(rawCardValue)) {
    return { isEligible: false };
  }

  // Ready to determine Possible CC
  const possibleCardTypes = getCardTypes(rawCardValue);
  // Check for at least one match
  if (notProperCreditCardType(possibleCardTypes)) {
    return { isEligible: false };
  }

  // Narrowed down to one Credit card type
  const cardType = possibleCardTypes[0];

  // Merchant Set Custom length Options
  if (notProperOptionalLength({ options, rawCardValue })) {
    return { isEligible: false, cardType: cardType };
  }

  /**
   *
   *   We have enough info to run luhn
   *   Value could still have an incomplete cc number
   *   and will continue to return isEligible = false, till
   *   criteria is met.
   *
   */
  return checkLuhn({ rawCardValue, cardType, options });
};
